import axios from '../axios/axios-auth'

export default class VehiclesGroupService {

    getOrganizationsGroups(orgId) {
        return axios.get(`/api/v3/vehiclesGroup/${orgId}`).then(response => response.data)
    }

    createVehiclesGroup(data) {
        return axios.post(`/api/v3/vehiclesGroup`, data).then(response => response.data)
    }

    updateVehiclesGroup(data) {
        return axios.patch(`/api/v3/vehiclesGroup`, data).then(response => response.data)
    }

    removeVehiclesGroup(groupId, data) {
        return axios.delete(`/api/v3/vehiclesGroup/${groupId}`, data).then(response => response.data)
    }
}
